import { ASSET_DESKTOP, ASSET_MOBILE } from '../elements/assets'
import { BUTTON, BUTTON_SETTINGS } from '../elements/link'

export const HERO_SIDE_IMAGE = `
...on heroSideImage_Entry {
  id
  typeHandle

  heading {
    html
  }
  description

  textTable {
    ... on textTable_TableRow {
      heading
      text
    }
  }

  ${ BUTTON }
  ${ BUTTON_SETTINGS }

  ${ ASSET_DESKTOP }
  ${ ASSET_MOBILE }
}
`